export default class UpdateRowOnDragEnd {
  async execute(event) {
    const movingNode = event.node;
    const overNode = event.overNode;
    const rowData = [];
    event.api.forEachNode((node) => rowData.push(node.data));

    // Row needs to move if row nodes are not equal
    if (movingNode !== overNode) {
      const fromIndex = rowData.indexOf(movingNode.data);
      const toIndex = rowData.indexOf(overNode.data);
      const newRowData = rowData.slice();
      newRowData.splice(fromIndex, 1);
      newRowData.splice(toIndex, 0, rowData[fromIndex]);
      event.api.setRowData(newRowData);
      event.api.clearFocusedCell();
      return newRowData;
    }
    return rowData;
  }
}
